import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { request } from "src/common/api";
import { GuestAuth } from "src/common/auth/socialAuth";
import {
  writeAccessToken,
  writeRefreshToken,
} from "src/common/functions/authFunctions";
import { userState } from "src/common/states/loginUser";
import { BaseResponse } from "src/common/types/baseRespones";
import * as S from "../../register/Register.style";
import { inputBox } from "src/pages/register/UserRegisterInfo";
import { showAlert } from "src/components/containers/Alert";

export const LoginPageNormal = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const [userId, setUserId] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const setUser = useSetRecoilState(userState);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navi = useNavigate();

  // 게스트 로그인
  const guestLogin = useMutation({
    mutationFn: (loginDto: any) =>
      request<BaseResponse>({
        method: "POST",
        url: `/auth/login`,
        data: loginDto,
      }),
    onSuccess: async (res: any) => {
      if (res.response.accessToken) writeAccessToken(res.response.accessToken);
      if (res.response.refreshToken)
        writeRefreshToken(res.response.refreshToken);
      if (res.response.user) setUser(res.response.user);

      navi("/");
    },
  });

  const handleGuestLogin = (userInfo: any) => {
    try {
      GuestAuth.login(() => guestLogin.mutate(userInfo));
    } catch (error) {
      console.error("게스트 로그인 오류:", error);
      // 오류 처리
      showAlert("게스트 로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const isAllFilled = !!userId && !!password;

  const data = isAllFilled
    ? [
        {
          userId,
          password,
        },
      ]
    : [];

  const handleSave = (userInfo: any) => {
    handleGuestLogin(userInfo);
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        maxHeight: "100vh",
        maxWidth: "45rem",
        margin: "0 auto",
        position: "relative",
        background: "#F7F7F7",
        overflow: "hidden",
        padding: "115px 16px 36px",
        boxSizing: "border-box",
      }}
    >
      {/* 로고 */}
      <div
        style={{
          // width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <div>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_987_41863)">
              <path
                d="M0 5.37815C0 2.40788 2.40788 0 5.37815 0H16C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16V5.37815Z"
                fill="#FAAE1D"
              />
            </g>
            <circle cx="13.5313" cy="12.3887" r="0.96" fill="#404040" />
            <circle cx="21.5313" cy="12.3887" r="0.96" fill="#404040" />
            <path
              d="M18.7408 14.4857C18.3308 15.2968 17.2779 15.4381 16.746 14.6494C16.4984 14.2811 15.9 14.6308 16.1512 14.9991C16.9528 16.1859 18.6743 16.145 19.3393 14.8354C19.5425 14.4373 18.944 14.0839 18.7445 14.4857H18.7408Z"
              fill="#404040"
            />
            <path
              d="M10.5353 3.35246C8.21742 4.13858 6.02363 5.87666 4.58854 8.48397"
              stroke="#FBD984"
              strokeOpacity="0.7"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <defs>
              <filter
                id="filter0_i_987_41863"
                x="0"
                y="0"
                width="32"
                height="34"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.929412 0 0 0 0 0.839216 0 0 0 0.41 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_987_41863"
                />
              </filter>
            </defs>
          </svg>
        </div>

        {/* 제목 및 설명 */}
        <div
          className="Frame1000004714"
          style={{
            width: isMobile ? "90%" : "262px",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: 4,
            display: "inline-flex",
          }}
        >
          <div
            className="Frame1000004713"
            style={{
              width: isMobile ? "100%" : "229px",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              display: "flex",
            }}
          >
            <div
              className="Frame1000004712"
              style={{
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 4,
                display: "inline-flex",
                flexWrap: isMobile ? "wrap" : "nowrap",
              }}
            >
              <div
                style={{
                  width: isMobile ? "auto" : "121px",
                  color: "#F57C00",
                  fontSize: isMobile ? 28 : 32,
                  fontFamily: "SB Aggro",
                  fontWeight: "400",
                  lineHeight: isMobile ? "40px" : "48px",
                  wordWrap: "break-word",
                }}
              >
                루틴케어
              </div>
              <div
                style={{
                  width: isMobile ? "auto" : "31px",
                  color: "#404040",
                  fontSize: isMobile ? 20 : 24,
                  fontFamily: "SB Aggro",
                  fontWeight: "400",
                  lineHeight: isMobile ? "30px" : "36px",
                  wordWrap: "break-word",
                }}
              >
                에{" "}
              </div>
            </div>
            <div
              style={{
                alignSelf: "stretch",
                color: "#404040",
                fontSize: isMobile ? 20 : 24,
                fontFamily: "SB Aggro",
                fontWeight: "400",
                lineHeight: isMobile ? "30px" : "36px",
                wordWrap: "break-word",
              }}
            >
              오신 것을 환영해요!
            </div>
          </div>
          <div
            style={{
              alignSelf: "stretch",
              color: "#A3A3A3",
              fontSize: isMobile ? 14 : 16,
              fontFamily: "Pretendard",
              fontWeight: "500",
              lineHeight: isMobile ? "20px" : "24px",
              wordWrap: "break-word",
            }}
          >
            간편 가입으로 건강 습관을 시작해보세요.
          </div>
        </div>
        {/* 로그인 버튼들 */}
        <div
          className="Frame427319054"
          style={{
            width: "100%",
            left: "0",
            bottom: "8%",
            position: "absolute",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 12,
            display: "inline-flex",
          }}
        >
          {/* 아이디 */}
          <div
            style={{
              //   display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                marginBottom: "4px",
              }}
            >
              <span
                style={{
                  fontSize: 16,
                  color: "#404040",
                  lineHeight: "24px",
                }}
              >
                아이디
              </span>
              <span
                style={{
                  width: 6,
                  height: 6,
                  background: "#F57C00",
                  borderRadius: "50%",
                }}
              />
            </label>
            <div
              style={{
                ...inputBox,
                width: "100%",
                height: 48,
                padding: "0 16px",
              }}
            >
              <S.InputNum
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="아이디를 입력해주세요"
              />
            </div>
          </div>

          {/* 비밀번호 */}
          <div
            style={{
              //   display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                marginBottom: "4px",
              }}
            >
              <span
                style={{
                  fontSize: 16,
                  color: "#404040",
                  lineHeight: "24px",
                }}
              >
                비밀번호
              </span>
              <span
                style={{
                  width: 6,
                  height: 6,
                  background: "#F57C00",
                  borderRadius: "50%",
                }}
              />
            </label>
            <div
              style={{
                ...inputBox,
                width: "100%",
                height: 48,
                padding: "0 16px",
              }}
            >
              <S.InputNum
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호를 입력해주세요"
              />
            </div>
          </div>

          {/* 로그인 버튼 */}
          <button
            onClick={() => {
              if (isAllFilled) {
                handleSave(data[0]);
              } else {
                showAlert("아이디 또는 비밀번호를 입력해주세요");
              }
            }}
            className="IdLogin"
            style={{
              width: "100%",
              height: "48px",
              alignSelf: "stretch",
              padding: "8px 20px",
              background: isAllFilled ? "#F57C00" : "#fbd5af",
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              border: "none",
              cursor: "pointer",
              marginTop: 12,
            }}
          >
            <div
              className="ButtonText"
              style={{
                width: isMobile ? "auto" : "116px",
                color: "white",
                fontSize: 16,
                fontFamily: "Pretendard",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              로그인
            </div>
          </button>
          <div
            onClick={() => navi("/register/join")}
            className="ButtonText"
            style={{
              width: "100%",
              textAlign: "center",
              color: "#262626",
              fontSize: 16,
              fontFamily: "Pretendard",
              fontWeight: "500",
              lineHeight: "24px",
              wordWrap: "break-word",
            }}
          >
            회원가입
          </div>

          {/* 다른 소셜 로그인 */}
          <button
            className="Frame5930"
            style={{
              width: isMobile ? "100%" : "320px",
              paddingLeft: 32,
              paddingRight: 32,
              paddingTop: 8,
              paddingBottom: 8,
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              display: "inline-flex",
              background: "transparent",
              border: "none",
            }}
          >
            <div
              onClick={() => navi("/auth/login")}
              style={{
                color: "#A3A3A3",
                fontSize: 16,
                fontWeight: "400",
                lineHeight: "24px",
                letterSpacing: "-0.32px",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              다른 방법으로 로그인
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
